
export const jobListData = [
  {
    id: 'job-001',
    badge: { text: 'VIP 채용관', color: 'bg-yellow-500' },
    position: '프리미엄 바텐더 급구',
    company: '라운지 퍼플',
    location: '강남',
    region: '서울',
    experience: '경력무관',
    salary: '월 400~600만원',
    salaryNum: 500,
    workType: '정규직',
    category: '바텐더',
    image: 'https://public.readdy.ai/ai/img_res/76e0be04ed41b059008840637899271d.jpg',
    views: 2847,
    applicants: 38,
    postedDate: '2025-06-28',
    isHot: true,
  },
  {
    id: 'job-002',
    badge: { text: 'TOP', color: 'bg-neon-pink' },
    position: '홀 매니저',
    company: '클럽 네온',
    location: '역삼',
    region: '서울',
    experience: '경력 1년',
    salary: '월 350만원',
    salaryNum: 350,
    workType: '정규직',
    category: '매니저',
    image: 'https://readdy.ai/api/search-image?query=modern%20upscale%20bar%20interior%20with%20purple%20neon%20lighting%20elegant%20counter%20sophisticated%20nightlife%20atmosphere%20premium%20lounge%20design&width=400&height=240&seq=jlist-2&orientation=landscape',
    views: 1523,
    applicants: 22,
    postedDate: '2025-06-30',
    isHot: false,
  },
  {
    id: 'job-003',
    badge: { text: 'TOP', color: 'bg-neon-pink' },
    position: '서버 모집',
    company: '바 미드나잇',
    location: '신사',
    region: '서울',
    experience: '신입가능',
    salary: '시급 2만원',
    salaryNum: 200,
    workType: '아르바이트',
    category: '서버',
    image: 'https://readdy.ai/api/search-image?query=stylish%20cocktail%20bar%20setup%20with%20purple%20ambient%20lighting%20premium%20bottles%20display%20modern%20nightclub%20interior%20sophisticated%20venue%20design&width=400&height=240&seq=jlist-3&orientation=landscape',
    views: 987,
    applicants: 15,
    postedDate: '2025-07-01',
    isHot: false,
  },
  {
    id: 'job-004',
    badge: { text: 'VIP 채용관', color: 'bg-yellow-500' },
    position: 'DJ 모집',
    company: '라운지 블랙',
    location: '청담',
    region: '서울',
    experience: '경력 3년',
    salary: '회당 30만원',
    salaryNum: 300,
    workType: '프리랜서',
    category: 'DJ',
    image: 'https://readdy.ai/api/search-image?query=professional%20DJ%20booth%20setup%20with%20purple%20LED%20lights%20modern%20nightclub%20turntable%20equipment%20dark%20ambient%20atmosphere%20premium%20venue&width=400&height=240&seq=jlist-4&orientation=landscape',
    views: 2103,
    applicants: 12,
    postedDate: '2025-06-25',
    isHot: true,
  },
  {
    id: 'job-005',
    badge: null,
    position: '캐셔 겸 안내',
    company: '클럽 루미에르',
    location: '홍대',
    region: '서울',
    experience: '신입가능',
    salary: '시급 1.5만원',
    salaryNum: 150,
    workType: '아르바이트',
    category: '서버',
    image: 'https://readdy.ai/api/search-image?query=modern%20reception%20desk%20area%20in%20upscale%20nightclub%20with%20warm%20ambient%20lighting%20sleek%20dark%20interior%20design%20premium%20entrance%20lobby&width=400&height=240&seq=jlist-5&orientation=landscape',
    views: 654,
    applicants: 8,
    postedDate: '2025-07-02',
    isHot: false,
  },
  {
    id: 'job-006',
    badge: { text: 'TOP', color: 'bg-neon-pink' },
    position: '바텐더 (경력)',
    company: '모던바 소울',
    location: '이태원',
    region: '서울',
    experience: '경력 2년',
    salary: '월 300만원',
    salaryNum: 300,
    workType: '정규직',
    category: '바텐더',
    image: 'https://readdy.ai/api/search-image?query=elegant%20modern%20bar%20with%20warm%20golden%20lighting%20premium%20whiskey%20bottles%20display%20sophisticated%20bartender%20workspace%20dark%20wood%20interior&width=400&height=240&seq=jlist-6&orientation=landscape',
    views: 1876,
    applicants: 29,
    postedDate: '2025-06-29',
    isHot: false,
  },
  {
    id: 'job-007',
    badge: null,
    position: '웨이터/웨이트리스',
    company: '라운지 아우라',
    location: '압구정',
    region: '서울',
    experience: '경력무관',
    salary: '시급 1.8만원',
    salaryNum: 180,
    workType: '아르바이트',
    category: '서버',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20VIP%20lounge%20area%20with%20plush%20seating%20warm%20purple%20ambient%20lighting%20premium%20nightlife%20service%20area%20elegant%20dark%20interior&width=400&height=240&seq=jlist-7&orientation=landscape',
    views: 432,
    applicants: 6,
    postedDate: '2025-07-03',
    isHot: false,
  },
  {
    id: 'job-008',
    badge: { text: 'VIP 채용관', color: 'bg-yellow-500' },
    position: '매장 총괄 매니저',
    company: '하이퍼블릭 강남',
    location: '강남',
    region: '서울',
    experience: '경력 5년',
    salary: '월 500만원+',
    salaryNum: 500,
    workType: '정규직',
    category: '매니저',
    image: 'https://readdy.ai/api/search-image?query=premium%20nightclub%20management%20office%20with%20modern%20dark%20interior%20glass%20walls%20overlooking%20dance%20floor%20sophisticated%20executive%20workspace&width=400&height=240&seq=jlist-8&orientation=landscape',
    views: 3201,
    applicants: 45,
    postedDate: '2025-06-27',
    isHot: true,
  },
  {
    id: 'job-009',
    badge: null,
    position: '보안 요원',
    company: '클럽 엘리트',
    location: '신논현',
    region: '서울',
    experience: '경력 1년',
    salary: '월 280만원',
    salaryNum: 280,
    workType: '정규직',
    category: '보안',
    image: 'https://readdy.ai/api/search-image?query=nightclub%20entrance%20security%20area%20with%20dark%20modern%20design%20velvet%20rope%20premium%20venue%20entrance%20sophisticated%20dark%20lighting&width=400&height=240&seq=jlist-9&orientation=landscape',
    views: 765,
    applicants: 11,
    postedDate: '2025-07-01',
    isHot: false,
  },
  {
    id: 'job-010',
    badge: { text: 'TOP', color: 'bg-neon-pink' },
    position: '칵테일 바텐더',
    company: '바 루프탑',
    location: '해운대',
    region: '부산',
    experience: '경력 2년',
    salary: '월 320만원',
    salaryNum: 320,
    workType: '정규직',
    category: '바텐더',
    image: 'https://readdy.ai/api/search-image?query=rooftop%20bar%20with%20ocean%20view%20at%20night%20warm%20ambient%20lighting%20cocktail%20preparation%20area%20modern%20outdoor%20lounge%20premium%20atmosphere&width=400&height=240&seq=jlist-10&orientation=landscape',
    views: 1432,
    applicants: 19,
    postedDate: '2025-06-30',
    isHot: false,
  },
  {
    id: 'job-011',
    badge: null,
    position: '홀 서빙 스태프',
    company: '모던바 블리스',
    location: '서면',
    region: '부산',
    experience: '신입가능',
    salary: '시급 1.6만원',
    salaryNum: 160,
    workType: '아르바이트',
    category: '서버',
    image: 'https://readdy.ai/api/search-image?query=modern%20bar%20serving%20area%20with%20sleek%20dark%20counters%20warm%20lighting%20premium%20glassware%20display%20sophisticated%20nightlife%20venue%20interior&width=400&height=240&seq=jlist-11&orientation=landscape',
    views: 321,
    applicants: 4,
    postedDate: '2025-07-04',
    isHot: false,
  },
  {
    id: 'job-012',
    badge: { text: 'VIP 채용관', color: 'bg-yellow-500' },
    position: '플로어 매니저',
    company: '클럽 파라다이스',
    location: '동성로',
    region: '대구',
    experience: '경력 3년',
    salary: '월 380만원',
    salaryNum: 380,
    workType: '정규직',
    category: '매니저',
    image: 'https://readdy.ai/api/search-image?query=spacious%20nightclub%20dance%20floor%20with%20colorful%20LED%20lighting%20system%20modern%20sound%20equipment%20dark%20premium%20venue%20interior%20sophisticated%20design&width=400&height=240&seq=jlist-12&orientation=landscape',
    views: 1098,
    applicants: 16,
    postedDate: '2025-06-26',
    isHot: true,
  },
];

export const jobCategories = ['전체', '바텐더', '서버', '매니저', 'DJ', '보안'];
export const jobRegions = ['전체', '서울', '부산', '대구', '인천', '대전'];
export const jobWorkTypes = ['전체', '정규직', '아르바이트', '프리랜서'];
export const jobExperiences = ['전체', '신입가능', '경력무관', '경력 1년', '경력 2년', '경력 3년', '경력 5년'];
